// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6048":"f7d66cc8","7249":"a34872b1"}[chunkId] + ".chunk.css";
};